const NUMBERS = new Uint32Array(1);
const Random = {
    getNumber: () => {
        crypto.getRandomValues(NUMBERS);
        return NUMBERS[0];
    }
}

export default Random;
